<template>
  <div>
    <v-row align="center" justify="center">
      <v-col cols="6">
        <div class="subtitle-1">Bản đồ phân bố cơ sở SXKD</div>
      </v-col>
      <v-col cols="6">
        <h4 class="text-right font-weight-light">
          Tìm thấy <span class="primary--text px-1">{{totalItems}}</span> cơ sở
        </h4>
      </v-col>
    </v-row>
    <v-row class="mt-0">
      <v-col cols="12">
        <v-card flat>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="12" md="3">
                <template v-if="loading">
                  <v-skeleton-loader
                    v-for="fakeItem in 7"
                    :key="`fake${fakeItem}`"
                    type="list-item-three-line"
                  />
                </template>
                <v-list-item-group
                  v-model="addressSelected"
                  active-class="primary--text"
                >
                  <v-list 
                    three-line 
                    class="scroll scroll-custom-primary"
                    :style="$vuetify.breakpoint.lgAndUp ? 'height: calc(70vh);' : 'height: 300px;'"
                  >
                    <template v-for="(item, index) in items">
                      <v-divider v-if="index > 0"/>
                      <v-list-item v-if="item" :key="`bus${index}`">
                        <v-list-item-avatar>
                          <v-icon v-if="item.toaDo">mdi-map-marker-radius</v-icon>
                          <v-icon v-else>mdi-map-marker-off</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title class="font-weight-medium" v-html="item.tenCoSo"></v-list-item-title>
                          <v-list-item-subtitle>Địa chỉ: 
                            <span v-if="item.duong">{{item.duong}},</span> {{item.dmXa.ten}}, {{item.dmHuyen.ten}}, {{item.dmTinh.ten}}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action v-if="addressSelected == index">
                          <v-btn icon>
                            <v-icon color="grey lighten-1">mdi-close</v-icon>
                          </v-btn>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn icon @click.stop="gmapDirections(item)"
                                v-bind="attrs"
                                v-on="on">
                                <v-icon color="primary lighten-1">mdi-directions</v-icon>
                              </v-btn>
                            </template>
                            <span>Chỉ dẫn</span>
                          </v-tooltip>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                    <template v-if="showMoreBtn">
                      <v-divider/>
                      <v-btn block color="primary" class="mt-2" @click.stop="loadDanhSach()" :loading="loadingMoreData">Tải thêm</v-btn>
                    </template>
                  </v-list>
                </v-list-item-group>
              </v-col>
              <v-col cols="12" sm="12" md="9">
                <BusinessMap :markersOri="markers" :items="itemToaDos" :addressSelected="addressSelected"/>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
    import BusinessMap from "@/components/public/business/BusinessMap";
    export default {
      props: {
        filterObj: {
          type: Object
        }
      },
      components: {
        BusinessMap
      },
      data () {
        return {
          loading: false,
          loadingMoreData: false,
          markers: [],
          currentPage: 0,
          pageSize: 20,
          totalPages: 0,
          totalItems: 0,
          items: [],
          itemToaDos: [],
          addressSelected: null,
          destination: {},
          showMoreBtn: true
        }
      },
      mounted() {
        this.loadDanhSach();
        this.loadToaDoOnly();
      },
      watch: {
        filterObj(){
          this.currentPage = 0;
          this.items = [];
          this.itemToaDos = [];
          this.showMoreBtn = true;
          this.loadDanhSach();
          this.loadToaDoOnly();
        }
      },
      methods: {
        loadToaDoOnly() {
          const app = this;
          app.addressSelected = null;
          app.markers = [];
          app.hasToaDo = [];
          app.hasNotToaDo = [];
          const params = {
            params: { 
              ...app.filterObj
            }
          };
          app.loading = true;
          axios.get("api/v1/public/get-agridata-breed-business-toado", params)
            .then(response => {
              response.data.forEach(function(item, index){
                let address = "";
                let main_address = `${item.dmXa.ten}, ${item.dmHuyen.ten}, ${item.dmTinh.ten}`;
                if(item.duong){
                  address = `${item.duong}, ${ main_address}`;
                } else {
                  address = main_address;
                }
                if(item.toaDo){
                  let lat = parseFloat(item.toaDo.trim().split(',')[0]);
                  let lng = parseFloat(item.toaDo.trim().split(',')[1]);

                  app.markers.push({
                    id: item.id,
                    name: item.tenCoSo,
                    location: address,
                    position: {
                      lat: lat,
                      lng: lng
                    }
                  });
                }
                app.itemToaDos.push(item);
              });
            }).catch(function (error) {
              console.log(error);
            });
            app.loading = false;
        },
        loadDanhSach() {
          const app = this;
          // if(app.totalPages > 0 && app.currentPage == app.totalPages) {
          //   app.showMoreBtn = false;
          //   return false;
          // }
          if(!app.showMoreBtn) {
            return false;
          }
          app.currentPage = app.currentPage + 1;
          const params = {
            params: {
              ...{
                page: app.currentPage++,
                size: app.pageSize
              }, 
              ...app.filterObj
            }
          };
          app.loadingMoreData = true
          axios.get("api/v1/public/get-agridata-breed-business", params)
            .then(response => {
              response.data.data.forEach(function(item, index){
                app.items.push(item)
              })
              const caluTotalPage = response.data.total/response.data.per_page;
              app.currentPage = response.data.current_page;
              app.totalItems = response.data.total;
              app.totalPages = Math.ceil(caluTotalPage);
              if(app.currentPage == app.totalPages){
                app.showMoreBtn = false;
              }
              
            })
            .catch(function (error) {
              console.log(error);
            })
            .then(function () {
              app.loadingMoreData = false
            });
        },
        gmapDirections(destination){
          navigator.geolocation.getCurrentPosition(function(pos) {
            let lat = parseFloat(destination.toaDo.trim().split(',')[0]);
            let lng = parseFloat(destination.toaDo.trim().split(',')[1]);
            window.location.href = `https://www.google.es/maps/dir/${pos.coords.latitude},${pos.coords.longitude}/${lat},${lng}`;
          })
        }
      }
    }
  </script>
  
  <style>
  .scroll {
    overflow-y: scroll
  }
  </style>